import React from "react";
import { CalendarCheck, Phone, ArrowRight, MapPin } from "lucide-react";
import { clinic, stats, heroImages } from "../mock";
import { useBooking } from "../App";
import { Button } from "./ui/button";

export default function Hero() {
  const { openBooking } = useBooking();
  return (
    <section id="inicio" className="relative hero-gradient text-white overflow-hidden">
      {/* subtle grid */}
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.6) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.6) 1px,transparent 1px)",
          backgroundSize: "46px 46px",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pt-[120px] pb-20 lg:pt-[150px] lg:pb-28 grid lg:grid-cols-2 gap-12 items-center">
        <div className="reveal is-visible">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-4 py-1.5 text-xs font-medium tracking-wide text-blue-100">
            <MapPin size={14} /> {clinic.city} · {clinic.region}
          </span>
          <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.08] mt-6">
            Oftalmología de{" "}
            <span className="text-gradient-blue">alta tecnología</span> en San Fernando
          </h1>
          <p className="text-base lg:text-lg text-blue-100/80 mt-6 max-w-xl leading-relaxed">
            Centro oftalmológico especializado en cirugía de Retina, Cataratas y Glaucoma,
            con equipamiento de última generación y un equipo humano cercano. Diagnóstico
            preciso y tratamiento oportuno para la Región de O'Higgins.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 mt-9">
            <Button
              onClick={openBooking}
              className="rounded-full bg-white text-[#0b2545] hover:bg-blue-50 h-12 px-7 text-base font-semibold shadow-xl shadow-blue-950/30"
            >
              <CalendarCheck size={18} className="mr-2" /> Reservar Hora
            </Button>
            <a href={`tel:${clinic.callCenterTel}`}>
              <Button
                variant="outline"
                className="w-full sm:w-auto rounded-full h-12 px-7 text-base font-semibold bg-transparent border-white/30 text-white hover:bg-white/10 hover:text-white"
              >
                <Phone size={18} className="mr-2" /> Call Center
              </Button>
            </a>
          </div>

          <div className="grid grid-cols-3 gap-3 mt-12 max-w-lg">
            {stats.map((s) => (
              <div key={s.label} className="glass-card rounded-2xl px-4 py-4">
                <div className="font-display font-extrabold text-2xl text-white">{s.value}</div>
                <div className="text-[11px] text-blue-100/70 mt-1 leading-tight">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative reveal is-visible">
          <div className="relative rounded-[28px] overflow-hidden border border-white/15 shadow-2xl shadow-blue-950/40 animate-floaty">
            <img
              src={heroImages.eyeMacro}
              alt="Detalle de un ojo humano"
              className="w-full h-[420px] lg:h-[540px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#071a33]/70 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 glass-card rounded-2xl px-5 py-4 flex items-center justify-between">
              <div>
                <div className="text-xs text-blue-100/70">Especialistas en</div>
                <div className="font-display font-bold text-white">Retina · Cataratas · Glaucoma</div>
              </div>
              <ArrowRight className="text-blue-200" size={22} />
            </div>
          </div>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-4 flex flex-wrap items-center justify-center gap-x-8 gap-y-2 text-xs text-blue-100/60">
          <span>Atención con FONASA · Valor preferencial</span>
          <span className="hidden sm:inline">•</span>
          <span>Reembolsable con ISAPRE</span>
          <span className="hidden sm:inline">•</span>
          <span>{clinic.addressNote}</span>
        </div>
      </div>
    </section>
  );
}
